export const GROUP_PATH_SEPARATOR = ' / ';

const ELISION = ' /.../ ';

// Deep paths keep their root and leaf; the leaf is what identifies the group.
export const elideGroupPath = (fullPath: string) => {
  const segments = fullPath.split(GROUP_PATH_SEPARATOR);

  if (segments.length <= 2) {
    return { label: fullPath, isElided: false };
  }

  return {
    label: `${segments.at(0)}${ELISION}${segments.at(-1)}`,
    isElided: true,
  };
};
